import { ConfigurationModel, LogLevel } from '@safra-frontend/core';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

interface ObcConfigurationModel extends ConfigurationModel {
  analytics: {
    gtm: string;
  };
}

export const environment: ObcConfigurationModel = {
  production: false,
  application: 'NFE',
  communication: {
    backend: {
      url: 'https://api-controlador-corp-ti.safra.com.br/apl-api-consentimento-obc',
      defaultTimeout: 5000,
    },
  },
  logging: {
    backend: {
      retry: 2,
      defaultTimeout: 5000,
      url: 'https://api-hml.safra.com.br/log',
    },
    level: LogLevel.INFO,
    lotSize: 50,
    consoleLogging: true,
  },
  cryptography: {
    isOn: false,
    retry: 2,
  },
  router: {
    authenticationRoute: '',
    safeRoutes: [
      '',
      '**',
      'home',
      'home/compartilhamentos',
      'home/pagamentos',
      'home/termos',
      'home/faq',
      'home/complementares/:consentId',
      'home/sucesso-cancelamento',
      'home/dados-descricao',
      'transmissora',
      'transmissora/erro-dados',
      'transmissora/dados-compartilhados',
      'transmissora/resumo-compartilhamento',
      'receptora',
      'receptora/tutorial',
      'receptora/termos',
      'receptora/pedido-compartilhamento',
      'receptora/lista-dados',
      'receptora/resumo-solicitacao',
      'receptora/solicitacao-compartilhamento',
      'receptora/liberacao',
      'receptora/dados-compartilhados',
      'receptora/confirmacao',
      'receptora-confirmacao',
      'callback',
      'receptora-simples',
      'receptora-simples/redirecionamento',
      'receptora-simples/termos',
      'receptora-simples/lista-participantes',
      'handoff',
      'handoff/redirecionamento',
      'deposito',
      'deposito/valor',
      'deposito/origem',
      'deposito/lista-instituicoes',
      'deposito/resumo',
      'deposito/redirecionamento',
      'deposito/confirmacao',
      'deposito/confirmacao-andamento',
      'deposito/termos',
    ],
    requiredStrategyGroups: [],
    timeout: 320000,
  },
  analytics: {
    gtm: 'GTM-WG8N6TT',
  },
};
